import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { formatNumberWithCommas } from "../../../../Common/AllDateTimeReleventFormate";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import { PAGE_SIZE } from "../../../../../redux/constants";
import { getPostPaginationList } from "../../../../../redux/project/action";
import OrderPostPagination from "../../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";
import PostStatusLabel from "../../../../Common/PostStatusLabel";

export default function CancelledJobs({ data }) {
  const path = "Assets/scss/myorders.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();

  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getJobCompleteList(3));
  // }, []);

  const [listdata, setListdata] = useState("")
  const [pageNumber, setPageNumber] = useState(0);


  useEffect(() => {
    const data = {
      type: 3,
      index: pageNumber,
      size: PAGE_SIZE,
      status: 24
    }
    if (data) {
      dispatch(getPostPaginationList(data)).then((res) => {
        setListdata(res)
      })
    }
  }, [pageNumber]);


  return (
    <div className="order-tabs">
      <div className="tab-content">
        <div className="posted-project">
          {Array.isArray(listdata?.response) && (
            <>
              <h4>Part time Job (PTJ)</h4>
              <OrderPostPagination
                totalitemcounts={listdata?.count}
                size={PAGE_SIZE}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
              />
              {listdata?.response?.length == 0 && <PostNotFound title={"No Post Found"} />}
              <div className="recent-post row recent-job">
                {listdata?.response.slice(0, 10).map((item, index) => (
                  <div className="col-md-6" key={index}
                    onClick={() =>
                      navigate(`/${lan}/dashboard/managework/jobs/active/${item.id}`)
                    }>
                    <div className="post-back recent-back">
                      <div className="recent-detail">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/myorders/jobtype.svg`}
                            alt=""
                          />
                          Job type:
                          {item?.work_location == 1
                            ? "Virtual"
                            : item?.work_location == 2
                              ? "Physical"
                              : ""}
                        </p>
                        <h3>{item?.title}</h3>
                        <PostStatusLabel status={item?.status} />
                        <div className="recent-detail">
                          <p>Total Payment Received</p>
                          <h3>
                            {`SAR ${formatNumberWithCommas(item?.payment_recieved)}`}
                          </h3>
                        </div>
                        <h1>
                          {/* {`SAR ${formatNumberWithCommas(item?.payment_recieved)}`} */}

                          {/* <h1>
                            SAR
                            {item?.hiring_type == 1
                              ? `${formatNumberWithCommas(item?.price)}/hr`
                              : ""}
                            {item?.hiring_type == 4
                              ? `${formatNumberWithCommas(item?.price)}/month`
                              : ""}
                          </h1> */}
                        </h1>
                      </div>
                      <div className="recent-detail">
                        <p>Logged hour</p>
                        <h3>{item?.logged_hours || 0} hrs</h3>
                      </div>
                      {/* <div className ="recent-detail">
                        <p>Total Payment Received</p>
                        <h3>SAR {item?.payment_recieved}</h3>
                      </div> */}
                      <button
                        className="btn"
                        onClick={() =>
                          navigate(
                            `/${lan}/dashboard/managework/jobs/active/${item.id}`,
                          )
                        }
                      >
                        View details
                        <img
                          src={`${CloudStorage.cloudurl}Assets/Images/homepage/right-arrow-orange.svg`}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
